import * as types from './types'
import Cabinets from '../../../services/api/cabinets';

export const actions = {
	getCabinets ({ commit }) {
		return new Promise((resolve, reject) => {
			Cabinets.getCabinets()
			.then(cabinets => {
				commit(types.SET_CABINETS, cabinets)
				resolve()
			})
			.catch(err => reject(err))
		})
	},
	getClientsByOfficeId ({commit}, officeId) {
		return new Promise((resolve, reject) => {
			Cabinets.getClientsByOfficeId(officeId)
			.then(clients => {
        // console.log(clients);
				commit(types.SET_CLIENTS_BY_OFFICEID, {officeId, clients})
				resolve()
			})
			.catch(err => reject(err))
		})
	},
	getAdvisorsByOfficeId ({commit}, officeId) {
		return new Promise((resolve, reject) => {
			Cabinets.getAdvisorsByOfficeId(officeId)
			.then(advisors => {
        // console.log(clients);
				commit(types.SET_ADVISORS_BY_OFFICEID, {officeId, advisors})
				resolve()
			})
			.catch(err => reject(err))
		})
	},
	getAdminByOfficeId ({commit}, officeId) {
		return new Promise((resolve, reject) => {
			Cabinets.getAdminByOfficeId(officeId)
			.then(admin => {
        // console.log(clients);
				commit(types.SET_ADMIN_BY_OFFICEID, {officeId, admin})
				resolve()
			})
			.catch(err => reject(err))
		})
	},
	getCabinetById ({commit}, __id) {
		return new Promise((resolve, reject) => {
            Cabinets.getCabinetById(__id).then((cabinet) => {
                resolve(cabinet)
            }).catch(() => {
				reject()
			})
        })
	},
    addCabinet ({ commit }, __cabinet) {
        return new Promise((resolve, reject) => {
            Cabinets.addCabinet(__cabinet).then((cabinet) => {
                commit(types.CREATE_CABINET, {cabinet})
                resolve()
            }).catch(() => {
				reject()
			})
        })
	},
	editCabinet ({commit}, __cabinet) {
		return new Promise((resolve, reject) => {
            Cabinets.editCabinet(__cabinet).then((cabinet) => {
                commit(types.EDIT_CABINET, {cabinet})
                resolve()
            }).catch(() => {
				reject()
			})
        })
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Cabinets/actions.js